import CheckIcon from '@mui/icons-material/Check';
import ListItem from '@mui/material/ListItem';
import MuiListItemButton from '@mui/material/ListItemButton';
import MuiListItemText from '@mui/material/ListItemText';
import IconButton from 'components/IconButton/IconButton';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toUserTimezone } from 'utils';
import { getUrl } from '../utils';

const NotificationListItem = ({ item, markRead, onClick }) => {
  const account = useSelector((state) => state.settings.account);
  const url = getUrl(item);
  return (
    <ListItem
      divider
      disablePadding
      secondaryAction={
        item.notifications_seen === '0' && (
          <IconButton
            edge="end"
            size="small"
            icon={<CheckIcon fontSize="small" />}
            onClick={() => markRead(item)}
          />
        )
      }
      key={item.hash}
    >
      <MuiListItemButton
        sx={{ cursor: url ? 'pointer' : 'default' }}
        component={url ? Link : 'div'}
        to={url}
        onClick={url ? onClick : undefined}
      >
        <MuiListItemText
          primary={item.notifications_text}
          secondary={toUserTimezone(
            item.notifications_created_at,
            account.account_timezone,
          ).fromNow()}
        />
      </MuiListItemButton>
    </ListItem>
  );
};

export default NotificationListItem;
